import { makeModule } from '@codium/codium-vue'

export const storeModule = makeModule('mediaOwners', {
  parent: 'lists'
})
